const ACCESS = 'auth_access_token';
const REFRESH = 'auth_refresh_token';
const ACCESS_EXPIRES_AT = 'auth_access_expires_at';

export function getStoredAccessToken(): string | null {
  try {
    return localStorage.getItem(ACCESS);
  } catch {
    return null;
  }
}

export function getStoredRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH);
  } catch {
    return null;
  }
}

/** @param expiresInSeconds TTL from API (`expiresIn`), used to refresh before access JWT expires */
export function setStoredTokens(
  accessToken: string,
  refreshToken: string,
  expiresInSeconds?: number,
): void {
  try {
    localStorage.setItem(ACCESS, accessToken);
    localStorage.setItem(REFRESH, refreshToken);
    if (expiresInSeconds != null && expiresInSeconds > 0) {
      localStorage.setItem(
        ACCESS_EXPIRES_AT,
        String(Date.now() + expiresInSeconds * 1000),
      );
    }
  } catch {
    /* ignore */
  }
}

export function getAccessTokenExpiresAt(): number | null {
  try {
    const raw = localStorage.getItem(ACCESS_EXPIRES_AT);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function clearStoredTokens(): void {
  try {
    localStorage.removeItem(ACCESS);
    localStorage.removeItem(REFRESH);
    localStorage.removeItem(ACCESS_EXPIRES_AT);
  } catch {
    /* ignore */
  }
}
